import { useEffect, useState } from 'react';
import type { ApplicationRow } from '../shared/types';
import useApplicationsService from './useApplicationsService';

const useApplicationsListData = () => {
  const { search } = useApplicationsService();

  const [rows, setRows] = useState<ApplicationRow[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);
    search({})
      .then(response => {
        if (!active) return;
        setRows(response.result ?? []);
        setTotalRecords(response.totalElements ?? 0);
      })
      .catch(cause => {
        if (active) setError(cause instanceof Error ? cause : new Error('Could not load applications.'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [search, reloadKey]);

  return {
    rows,
    totalRecords,
    isLoading,
    error,
    retry: () => setReloadKey(value => value + 1),
  };
};

export default useApplicationsListData;
